import { render } from "./ConfirmationComponent.vue?vue&type=template&id=db9d4f34&ts=true"
import script from "./ConfirmationComponent.ts?vue&type=script&lang=ts"
export * from "./ConfirmationComponent.ts?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src1967141790/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__